import {environment} from "./environment";

// Authentication
export const signInApi = () => environment.baseUrl + '/api/v1/user/adminLogin';
export const forgotPasswordApi = () => environment.baseUrl + '/api/v1/user/forgotPassword';
export const resendOTPApi = () => environment.baseUrl + '/api/v1/user/resendOtpAdmin';
export const enterOtpApi = () => environment.baseUrl + '/api/v1/user/verifyOtpAdmin';
export const resetPinApi = () => environment.baseUrl + '/api/v1/user/resetPasswordAdmin';
export const changePin = () => environment.baseUrl + '/api/v1/user/changePinAdmin';


// Country
export const addCountry = () => environment.baseUrl + '/api/v1/country/create';
export const countryList = () => environment.baseUrl + '/api/v1/country/list';
export const countryDetails = () => environment.baseUrl + '/api/v1/country/details';
export const countryUpdate = () => environment.baseUrl + '/api/v1/country/update';
export const countryDelete = () => environment.baseUrl + '/api/v1/country/delete';
export const countryStatusChange = () => environment.baseUrl + '/api/v1//country/changeStatus';


export const addpromotionalAddonPlan = () => environment.baseUrl + '/api/v2/promotionalAddon/create';
export const promotionalAddonPlanList = () => environment.baseUrl + '/api/v2/promotionalAddon/list';
export const promotionalAddonDetails = () => environment.baseUrl + '/api/v2/promotionalAddon/details';
export const promotionalAddonUpdate = () => environment.baseUrl + '/api/v2/promotionalAddon/update';
export const promotionalAddonDelete = () => environment.baseUrl + '/api/v2/promotionalAddon/deletePlan';
export const promotionalAddonPlanStatusChange = () => environment.baseUrl + '/api/v2/promotionalAddon/changeStatus';

//State
export const addState = () => environment.baseUrl + '/api/v1/state/create';
export const stateList = () => environment.baseUrl + '/api/v1/state/list';
export const stateDetails = () => environment.baseUrl + '/api/v1/state/details';
export const stateUpdate = () => environment.baseUrl + '/api/v1/state/update';
export const stateDelete = () => environment.baseUrl + '/api/v1/state/delete';

// Services
export const imageUpload = () => environment.baseUrl + '/api/v1/user/uploadImage';
export const imageLocation = environment.baseUrl + '/upload/profiles/';
export const addServices = () => environment.baseUrl + '/api/v1/servicesCategory/create';
export const servicesList = () => environment.baseUrl + '/api/v1/servicesCategoryForAdmin/list';
export const servicesDetail = () => environment.baseUrl + '/api/v1/servicesCategory/getDetails';
export const servicesUpdate = () => environment.baseUrl + '/api/v1/servicesCategory/update';
export const servicesDelete = () => environment.baseUrl + '/api/v1/servicesCategory/delete';

// Services Category
// export const imgPath = environment.baseUrl + '/upload/services/'
export const addServiceCategory = () => environment.baseUrl + '/api/v1/category/create';
export const serviceCategoryList = () => environment.baseUrl + '/api/v1/category/list';
export const serviceCategoryDetail = () => environment.baseUrl + '/api/v1/category/getDetail';
export const serviceCategoryUpdate = () => environment.baseUrl + '/api/v1/category/update';
export const serviceCategoryDelete = () => environment.baseUrl + '/api/v1/category/delete';
export const status = () => environment.baseUrl + '/api/v1/category/changeStatus';

// Service Provider
export const serviceProviderAdd = () => environment.baseUrl + '/api/v1/leadsManagement/createProviderDirect';
export const serviceProviderList = () => environment.baseUrl + '/api/v1/provider/listForProvider';
export const serviceProviderDelete = () => environment.baseUrl + '/api/v1/provider/delete';
export const serviceProviderUpdate = () => environment.baseUrl + '/api/v1/provider/update';
export const serviceProviderDetails = () => environment.baseUrl + '/api/v1/provider/getDetails';
export const changeStatus = () => environment.baseUrl + '/api/v1/provider/changeStatus';
export const listBranches = () => environment.baseUrl + '/api/v2/admin/listBranches';
export const listClient = () => environment.baseUrl + '/api/v2/admin/listClient';
export const listCategory = () => environment.baseUrl + '/api/v2/admin/listCategory';
export const listStaff = () => environment.baseUrl + '/api/v2/admin/listStaff';
export const listService = () => environment.baseUrl + '/api/v2/admin/listService';
export const exportExcelData = () => environment.baseUrl + '/api/v2/admin/exportExcelData';




// User
export const userAdd = () => environment.baseUrl + '/api/v1/user/create';
export const userList = () => environment.baseUrl + '/api/v1/user/list';
export const userDelete = () => environment.baseUrl + '/api/v1/user/delete';
export const userUpdate = () => environment.baseUrl + '/api/v1/user/update';
export const userDetails = () => environment.baseUrl + '/api/v1/user/getDetails';
export const businessCategoryList = () => environment.baseUrl + '/api/v1/businessCategory/list';

// Blog
export const blogAdd = () => environment.baseUrl + '/api/v1/blog/create';
export const blogList = () => environment.baseUrl + '/api/v1/blog/list';
export const blogDelete = () => environment.baseUrl + '/api/v1/blog/Delete';
export const blogUpdate = () => environment.baseUrl + '/api/v1/blog/update';
export const blogDetails = () => environment.baseUrl + '/api/v1/blog/detail';

// Profile
export const profile = () => environment.baseUrl + '/api/v1/user/getBasicDetails'
export const updateProfile = () => environment.baseUrl + '/api/v1/user/updateProfileAdmin'

// Business

export const businessCreate = () => environment.baseUrl + '/api/v1/businessCategory/create';
export const businessList = () => environment.baseUrl + '/api/v1/businessCategory/list';
export const businessDetails = () => environment.baseUrl + '/api/v1/businessCategory/getDetails';
export const businessUpdate = () => environment.baseUrl + '/api/v1/businessCategory/update';
export const businessDelete = () => environment.baseUrl + '/api/v1/businessCategory/delete';
export const businessStatus = () => environment.baseUrl + '/api/v1/businessCategory/changeStatus';

// Appointment           
export const appointmentList = () => environment.baseUrl + '/api/v1/appointment/lisAdminAppointments';
export const appointmentView = () => environment.baseUrl + '/api/v1/appointment/getappointment';

export const clients = () => environment.baseUrl + '/api/v1/client/filterList';
export const teams = () => environment.baseUrl + '/api/v1/staff/filterList';

/* FAQ */
export const faqCreate = () => environment.baseUrl + '/api/v1/faq/create'
export const faqList = () => environment.baseUrl + '/api/v1/faq/list'
export const faqDetail = () => environment.baseUrl + '/api/v1/faq/view'
export const faqUpdate = () => environment.baseUrl + '/api/v1/faq/update'
export const faqDelete = () => environment.baseUrl + '/api/v1/faq/deleteFaq'


// Contact
export const contactList = () => environment.baseUrl + '/api/v1/contactUs/list';
export const contactDetail = () => environment.baseUrl + '/api/v1/contactUs/view';
export const contactDelete = () => environment.baseUrl + '/api/v1/contactUs/delete';

// logout
export const logOutApi = () => environment.baseUrl + '/api/v1/user/logout';

// Dashboard
// export const appointments = () => environment.baseUrl + '/api/v1/dashboard/appointmentAndServicesAdmin';
export const revenue = () => environment.baseUrl + '/api/v1/dashboard/revenueAdmin';
export const adminDashboardReport = () => environment.baseUrl + '/api/v1/purchasePlan/AdminDashboardReport';
export const revenuePieChartAdmin = () => environment.baseUrl + '/api/v1/purchasePlan/revenuePieChartAdmin';
export const revenueAdmin = () => environment.baseUrl + '/api/v1/purchasePlan/revenueGraphAdmin';

// Time Zone
// export const createTimeZone = () => environment.baseUrl + '/api/v1/timezone/createTimezone';
export const timeZoneList = () => environment.baseUrl + '/api/v1/timezone/list'
export const updateTimeZone = () => environment.baseUrl + '/api/v1/timezone/updateTimezone';


// Subscription
export const planAdd = () => environment.baseUrl + '/api/v1/subscriptionplan/savePlanData';
export const planList = () => environment.baseUrl + '/api/v1/subscriptionplan/getPlanList';
export const planStatusChange = () => environment.baseUrl + '/api/v1/subscriptionplan/changeStatus';
export const planDelete = () => environment.baseUrl + '/api/v1/subscriptionplan/planDelete';
export const planDetail = () => environment.baseUrl + '/api/v1/subscriptionplan/getPlanDetail';
export const planUpdate = () => environment.baseUrl + '/api/v1/subscriptionplan/updatePlanData';



export const addPromocode = () => environment.baseUrl + '/api/v1/promocode/addPromocode';
export const promoPlanData = () => environment.baseUrl + '/api/v1/subscriptionplan/promoPlanData';
export const promoPlanList = () => environment.baseUrl + '/api/v1/promocode/promocodeList';
export const details = () => environment.baseUrl + '/api/v1/promocode/details';
export const updatePromocode = () => environment.baseUrl + '/api/v1/promocode/updatePromocode';

// export const queryList = () => environment.baseUrl + '/api/v1/customPlan/getcontactusdata';
export const queryView = () => environment.baseUrl + '/api/v1/customPlan/getCustomPlanId';
// export const planAssign = () => environment.baseUrl + '/api/v1/subscriptionplan/assignCustomPlan';


export const leadList = () => environment.baseUrl + '/api/v1/leadsManagement/list';
export const leadHistory = () => environment.baseUrl + '/api/v1/leadsManagement/leadHistory';
export const reSendInvitationMail = () => environment.baseUrl + '/api/v1/marketingTeam/reSendInvitationMail';
export const createLeadsMarketingTeam = () => environment.baseUrl + '/api/v1/leadsManagement/createLeadsMarketingTeam';
export const listMarketingTeam = () => environment.baseUrl + '/api/v1/marketingTeam/listMarketingTeam';
export const listMarketingTeamAll = () => environment.baseUrl + '/api/v1/marketingTeam/listMarketingTeamAll';
export const create = () => environment.baseUrl + '/api/v1/marketingTeam/create';
export const changeStatusMarketingTeam = () => environment.baseUrl + '/api/v1/marketingTeam/changeStatus';
export const assignMarketingTeam = () => environment.baseUrl + '/api/v1/leadsManagement/assignMarketingTeam';
export const createProvider = () => environment.baseUrl + '/api/v1/leadsManagement/createProvider';
export const leadsClose = () => environment.baseUrl + '/api/v1/leadsManagement/leadsClose';
export const leadsComplete = () => environment.baseUrl + '/api/v1/leadsManagement/leadsComplete';
export const leadsReopen = () => environment.baseUrl + '/api/v1/leadsManagement/leadsReopen';
export const view = () => environment.baseUrl + '/api/v1/leadsManagement/view';
export const leadsEdit = () => environment.baseUrl + '/api/v1/leadsManagement/leadsEdit';
export const deleteLeads = () => environment.baseUrl + '/api/v1/leadsManagement/deleteLeads';

export const planAssign = () => environment.baseUrl + '/api/v1/subscriptionplan/assignPlan';
export const freePlanAssign = () => environment.baseUrl + '/api/v1/subscriptionplan/assignFreePlan';
export const updatePlanDate = () => environment.baseUrl + '/api/v1/subscriptionplan/updatePlanDate';
export const resendInvitation = () => environment.baseUrl + '/api/v1/subscriptionplan/resend-Invitation';




export const customPlanList = () => environment.baseUrl + '/api/v1/subscriptionplan/customPlanList';
export const createPinApi = () => environment.baseUrl + '/api/v1/marketingTeam/createPin';


export const createCancellation = () => environment.baseUrl + '/api/v1/subscriptionplan/createCancellation';
export const listCancellation = () => environment.baseUrl + '/api/v1/subscriptionplan/listCancellation';
export const viewCancellation = () => environment.baseUrl + '/api/v1/subscriptionplan/viewCancellation';
export const updateCancellation = () => environment.baseUrl + '/api/v1/subscriptionplan/updateCancellation';


export const getMyPlan = () => environment.baseUrl + '/api/v1/subscriptionplan/getMyPlan';
export const planHistory = () => environment.baseUrl + '/api/v1/subscriptionplan/getUpdatePlanHistory';
export const getAssignPlan = () => environment.baseUrl + '/api/v1/subscriptionplan/getAssignPlan';
export const updateCurrentplan = () => environment.baseUrl + '/api/v1/subscriptionplan/updateCurrentplan';
export const getBalanceAmount = () => environment.baseUrl + '/api/v1/subscriptionplan/getBalanceAmount';
export const checkRefundPrice = () => environment.baseUrl + '/api/v1/purchasePlan/checkRefundPrice';
export const CancelPlan = () => environment.baseUrl + '/api/v1/purchasePlan/CancelPlan';
export const CancelPlanStripe = () => environment.baseUrl + '/api/v1/purchasePlan/CancelPlanStripe';
export const checkMendatory = () => environment.baseUrl + '/api/v1/branch/checkMendatory';

export const myPlanHistory = () => environment.baseUrl + '/api/v1/purchasePlan/myPlanHistory';
// export const paymentHistoryDetail = () => environment.baseUrl + '/api/v1/purchasePlan/paymentHistoryDetail';
export const myPlanPaymentHistory = () => environment.baseUrl + '/api/v1/purchasePlan/myPlanPaymentHistory';


export const paymentList = () => environment.baseUrl + '/api/v1/purchasePlan/getplanPaymentByPortal';
export const getPaymentStatus = () => environment.baseUrl + '/api/v1/purchasePlan/getPaymentStatus';
export const planAssignToProvider = () => environment.baseUrl + '/api/v1/purchasePlan/planAssignToProvider';


export const assignBranch = () => environment.baseUrl + '/api/v1/subscriptionplan/assignBranch';
export const assignTeam = () => environment.baseUrl + '/api/v1/subscriptionplan/assignTeam';
// export const assignservice = () => environment.baseUrl + '/api/v1/subscriptionplan/assignservice';
export const assignservice = () => environment.baseUrl + '/api/v2/services/listMultipleServicesAdmin';

export const notificationList = () => environment.baseUrl + '/api/v1/notification/list';
export const notificationReadSingle = () => environment.baseUrl + '/api/v1/notification/readSingle';
export const notificationReadAll = () => environment.baseUrl + '/api/v1/notification/readAll';
export const deleteImage = () => environment.baseUrl + '/api/v2/user/deleteImage';


export const listRole = () => environment.baseUrl + '/api/v1/role/list';
export const createRole = () => environment.baseUrl + '/api/v1/role/create';

export const createDuration = () => environment.baseUrl + '/api/v1/duration/createAdmin';
export const durationList = () => environment.baseUrl + '/api/v1/duration/listAdmin';
export const durationStatus = () => environment.baseUrl + '/api/v1/duration/changeStatusAdmin';
export const durationDelete = () => environment.baseUrl + '/api/v1/duration/deleteAdmin';

// Campaign Contact
export const createContact = () => environment.baseUrl + '/api/v2/campaign/createContact';
export const updateContact = () => environment.baseUrl + '/api/v2/campaign/updateContact';
export const listContact = () => environment.baseUrl + '/api/v2/campaign/getContact';
export const deleteContact = () => environment.baseUrl + '/api/v2/campaign/delete';
export const contactStatus = () => environment.baseUrl + '/api/v2/campaign/Status';
export const detailContact = () => environment.baseUrl + '/api/v2/campaign/detailContact';

// Campaign Group
export const listGroup = () => environment.baseUrl + '/api/v2/campaign/getContactGroup';
export const createGroup = () => environment.baseUrl + '/api/v2/campaign/getContactGroup';
export const detailGroup = () => environment.baseUrl + '/api/v2/campaign/getContactGroupDetail';

// Campaign 
export const createCampaign = () => environment.baseUrl + '/api/v2/campaign/createCampaign';
export const updateCampaign = () => environment.baseUrl + '/api/v2/campaign/updateCampaign';
export const deleteCampaign = () => environment.baseUrl + '/api/v2/campaign/Campaigndelete';
export const campaignStatus = () => environment.baseUrl + '/api/v2/campaign/CampaignStatus';
export const listCampaign = () => environment.baseUrl + '/api/v2/campaign/getCampaign';
export const detailCampaign = () => environment.baseUrl + '/api/v2/campaign/detailCampaign';
export const contactandGroupList = () => environment.baseUrl + '/api/v2/campaign/allList';
export const campaignMail = () => environment.baseUrl + '/api/v2/campaign/campaignMail';
export const imageUploadApi = () => environment.baseUrl + '/api/v1/user/uploadImage'
export const getWebhookList = () => environment.baseUrl + '/api/v2/whatsapp/webhook/list'
export const imgPath = environment.baseUrl + '/upload/services/thumbnail/'
